import { steps, ticker } from "@/mocks/freegua";

export default function Steps() {
  return (
    <section className="relative overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute -right-16 top-10 h-56 w-56 rounded-full bg-secondary-100/70 blur-3xl" />
      <div className="pointer-events-none absolute -left-20 bottom-0 h-56 w-56 rounded-full bg-accent-100/60 blur-3xl" />

      <div className="relative mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col items-center text-center">
          <span className="font-label text-sm font-bold tracking-widest text-accent-600">如何零元围观</span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            三步上手，不注册也能看得明白
          </h2>
          <p className="mt-4 max-w-2xl text-base text-foreground-600">
            免费吃瓜不设会员，从点开那一刻起就算上了车。想知道自己怎么轻松把一则瓜从起点看到收尾，看这里。
          </p>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {steps.map((s, i) => (
            <article
              key={s.step}
              className={`hover-lift relative overflow-hidden rounded-2xl border border-background-200/80 bg-background-100 p-6 md:p-7 ${
                i === 1 ? "md:-mt-3" : ""
              }`}
            >
              <span className="absolute right-5 top-4 font-heading text-5xl font-black text-background-200" aria-hidden="true">
                {s.step}
              </span>
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className={`${s.icon} text-xl`} aria-hidden="true" />
              </div>
              <h3 className="mt-5 text-lg font-extrabold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-accent-700">
                不花钱
                <i className="ri-check-line" aria-hidden="true" />
                不注册
                <i className="ri-check-line" aria-hidden="true" />
              </span>
            </article>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-x-2 gap-y-2 overflow-hidden rounded-2xl bg-background-100 px-4 py-3">
          <span className="mr-1 flex items-center gap-1.5 whitespace-nowrap text-sm font-bold text-foreground-800">
            <i className="ri-chat-voice-line text-accent-600" aria-hidden="true" />
            围观频道正在流动
          </span>
          {ticker.map((t, i) => (
            <span key={t} className="flex items-center gap-1.5 whitespace-nowrap text-sm text-foreground-600">
              {i > 0 && <i className="ri-arrow-right-s-line text-background-400" aria-hidden="true" />}
              <i className={`${i % 2 ? "ri-flashlight-fill" : "ri-add-line"} text-primary-500`} aria-hidden="true" />
              {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}